export type ValidationErrorMap = {
  email?: boolean;
  required?: boolean;
  anyOfRequired?: string[];
  pattern?: { pattern: string };
  minlength?: { requiredLength: number };
  maxlength?: { requiredLength: number };
  min?: { min: number };
  max?: { max: number };
  equal?: boolean;
  notEqual?: boolean;
  duplicate?: boolean;
  custom?: string;
  customParameters?: Record<string, any>;
} & {
  // all other properties (Not defined in DefaultKeys) will be added to `customErrors` and visualized in modal footer.
  [property: string]: {
    key: string;
    parameters?: any;
  };
};

export enum ReservedValidationKeys {
  email,
  required,
  anyOfRequired,
  pattern,
  minlength,
  maxlength,
  min,
  max,
  equal,
  notEqual,
  // `custom` and `customParameters` are reserved for backwards compatibility (form validations prior to this addition)
  custom,
  customParameters,
}
